export default __webpack_public_path__ + "static/media/materiaprima-05.124746ca.jpg";